import Vue from "vue";

import StockAlert from "./StockAlert.vue";

export function load() {
    const selector = "stock-alert";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(StockAlert, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
